import React, { useEffect, useState } from 'react';
import SEO from '../../components/SEO/SEO';
import './SwiftLinkDownloadsPage.css';

const SwiftLinkDownloadsPage = ({ darkMode }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  return (
    <div className={`swiftlink-page ${darkMode ? 'dark' : 'light'}`}>
      <SEO
        title="SwiftLinkERP | E-ASY"
        description="SwiftLinkERP es el entorno de gestión empresarial de E-ASY. Accede a información general y soporte técnico desde esta página."
        keywords="SwiftLinkERP, ERP, soporte SwiftLinkERP, gestión empresarial, E-ASY"
        canonical="https://e-asy.es/swiftlink-downloads"
      />

      <div className="time-display">
        <div className="time-date">
          {currentTime.toLocaleDateString('es-ES', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </div>
        <div className="time-hour">
          {currentTime.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          })}
        </div>
      </div>

      {!showForm ? (
        <div className="main-content">
          <h1 className="main-title">SwiftLinkERP</h1>
          <p className="main-subtitle-secondary">
            Tu espacio de gestión empresarial para trabajar con más control, más claridad y menos fricción.
          </p>

          <div className="notice-banner">
            <p className="notice-text">
              Bienvenido a <strong>SwiftLinkERP</strong>. Desde aquí accedes a tu entorno de trabajo habitual. Si
              necesitas ayuda, soporte o resolver cualquier incidencia, puedes contactar con nuestro equipo desde este
              mismo espacio.
            </p>
          </div>

          <div className="cta-section">
            <button className="support-button" onClick={toggleForm}>
              ¿Necesitas ayuda?
            </button>
          </div>
        </div>
      ) : (
        <div className="form-content">
          <div className="form-header">
            <h2 className="form-title">Formulario de Soporte</h2>
            <p className="form-subtitle">
              Completa el formulario con los detalles de tu consulta. Nuestro equipo te responderá lo antes posible.
            </p>
          </div>

          <div className="hubspot-form-container">
            <iframe
              src="https://share-eu1.hsforms.com/1n-Wy2taSR8ml-XuJJrFlgAfbhti"
              width="100%"
              height="700"
              frameBorder="0"
              title="Formulario de Soporte Técnico SwiftLinkERP"
              style={{ border: 'none', borderRadius: '12px' }}
            ></iframe>
          </div>

          <div className="back-section">
            <button className="back-button" onClick={toggleForm}>
              Volver
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SwiftLinkDownloadsPage;